import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';

var _templateObject;
var StyledInput = styled('input')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  opacity: 0;\n  position: absolute;\n  height: 1rem;\n  width: 1rem;\n  left: 0;\n  &:checked + span {\n    background-image: url(\"data:image/svg+xml;charset=utf8,\n        %3Csvg xmlns='http://www.w3.org/2000/svg'\n        viewBox='0 0 8 8'%3E%3Cpath fill='%23", "'\n        d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\");\n    background-position: 1px;\n    background-repeat: no-repeat;\n    background-size: 11px 13px;\n  }\n  &:checked + span:after {\n    display: block;\n  }\n  &:focus + span {\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n  &[disabled] ~ span:first-of-type {\n    opacity: 0.3;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.primary.substring(1);
}, function (_ref2) {
  var error = _ref2.error,
    theme = _ref2.theme;
  return !!error ? theme.palette.error : theme.palette.secondary;
}, function (_ref3) {
  var error = _ref3.error,
    theme = _ref3.theme;
  return !!error ? "0 0 3px ".concat(theme.palette.error) : theme.boxShadow.buttonFocus;
});
var CheckboxBox = withDefaultTheme(/*#__PURE__*/memo(StyledInput));

export default CheckboxBox;
